<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3" v-if="!hideTabs">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Campaigns",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        hideTabs(){
            if (this.$route.name.toLowerCase().includes("new")) {
                return true
            }
            return false
        },

        tabs() {
            let tabs =  [
                {
                    name: { el: "Καμπάνιες", en: "Campaigns", it: "Campagne" },
                    to: `/${this.lang}/loyaltyPanel/campaigns/view-campaigns`,
                }
            ]
            if (this.getPermission('rewards.read')) {
                tabs.push({
                    name: { el: "Επιβραβεύσεις", en: "Rewards", it: "Premi" },
                    to: `/${this.lang}/loyaltyPanel/campaigns/view-rewards`,
                })
            }
            tabs.push(
            {
                name: { el: "Πρότυπα email", en: "Email Themes", it: "Modelli di email" },
                to: `/${this.lang}/loyaltyPanel/campaigns/email-themes`,
            })
           
            return tabs
        },
    },
    methods: {
        ...mapActions(["getPermission"])
    },
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/campaigns`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/campaigns/view-campaigns`
                    );
                }
            },
        },
    },
};
</script>
